export default __webpack_public_path__ + "static/media/UI_Button.f4df4ad0.mp3";